module.exports = __webpack_public_path__ + "static/media/28GalleryPuppets.5f315bf8.jpeg";